import { IonBadge, IonButton, IonCol, IonContent, IonGrid, IonIcon, IonImg, IonLabel, IonNote, IonRow } from "@ionic/react";
import { t } from "i18next";
import { pinSharp } from "ionicons/icons";
import moment from "moment";
import React, { useEffect } from "react";
import { config } from "../../app.config";
import { Attachments } from "../../components/Attachments";
import { TrixContent } from "../../components/TrixContent";

const formatDateTime = (dateFormat: string, timeFormat: string, date: string, includeDate = true) => {
  const mmnt = moment(new Date(date));
  let formattedDateTime = "";

  if (includeDate) {
    formattedDateTime = mmnt.format(dateFormat) + " ";
  }

  formattedDateTime += mmnt.format(timeFormat);

  return formattedDateTime;
};

export const ViewEvent = (props: any) => {
  const [startEndDateTime, setStartEndDateTime] = React.useState<string>("");
  const [mapUrl, setMapUrl] = React.useState<string>("");

  useEffect(() => {
    if (props.event.allDay) {
      setStartEndDateTime("");
    } else {
      const start = new Date(props.event.start);
      const end = new Date(props.event.end);

      if (start.getDate() === end.getDate()) {
        setStartEndDateTime(`${formatDateTime(props.dateFormat, props.timeFormat, props.event.start)} - ${formatDateTime(props.dateFormat, props.timeFormat, props.event.end, false)}`);
      } else {
        setStartEndDateTime(`${formatDateTime(props.dateFormat, props.timeFormat, props.event.start)} - ${formatDateTime(props.dateFormat, props.timeFormat, props.event.end)}`);
      }
    }
  }, [props.event.start, props.event.end, props.event.allDay, props.dateFormat, props.timeFormat]);

  useEffect(() => {
    setMapUrl(`https://www.google.com/maps/search/?api=1&query=${props.event.address}`);
  }, [props.event.address]);

  const signUp = () => {
    props.onSignUp();
  };

  const unSignUp = () => {
    props.onUnSignUp();
  };

  /*const { data, isLoading, errorMessage } = useOpenWeather({
    key: config.openweather.api_key,
    lat: props.event.address?.coordinates[1],
    lon: props.event.address?.coordinates[0],
    lang: "en",
    unit: "metric", // values are (metric, standard, imperial)
  });*/

  return (
    <IonContent className={"ion-padding"}>
      <IonLabel
        className={"event-title"}
        style={{
          marginBottom: "8px",
        }}
      >
        <h1>
          <span
            style={{
              color: props.event.color,
              fontSize: 36,
              lineHeight: "24px",
              display: "inline-block",
              verticalAlign: "middle",
            }}
          >
            &bull;
          </span>
          <span
            style={{
              marginLeft: "0.25em",
              display: "inline-block",
            }}
          >
            {props.event.title}
          </span>
        </h1>
      </IonLabel>

      <div>
        <IonBadge
          style={{
            border: `1px solid ${props.event.color}`,
            "--background": "#fff",
            "--color": "#000",
          }}
        >
          {props.event.type}
        </IonBadge>
      </div>

      {startEndDateTime.length ? <IonLabel className={"block ion-margin-top"}>{startEndDateTime}</IonLabel> : ""}

      {props.event.location ? (
        <IonLabel className={"block ion-margin-top ion-margin-bottom"}>
          <IonIcon icon={pinSharp} slot={"start"} />
          {props.event.address ? (
            <a href={mapUrl} target={"_blank"} rel={"noopener noreferrer"}>
              {props.event.location}
            </a>
          ) : (
            props.event.location
          )}
        </IonLabel>
      ) : (
        ""
      )}

      {/*
      <ReactWeather
        isLoading={isLoading}
        errorMessage={errorMessage}
        data={data}
        lang={"en"}
        unitsLabels={{
          temperature: "c",
        }}
        showForecast
      />*/}

      {props.event.address ? (
        <a href={mapUrl} target={"_blank"} rel={"noopener noreferrer"}>
          <IonImg
            src={`https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(props.event.address)}&zoom=14&size=600x240&maptype=terrain&markers=color:${encodeURIComponent(props.event.color.replace("#", "0x"))}%7Clabel:%7C${encodeURIComponent(props.event.address)}&key=${config.google.api_key}`}
            style={{
              border: "1px solid #ccc",
              borderRadius: "10px",
            }}
          />
        </a>
      ) : (
        ""
      )}

      <h5 className={"separator-heading"}>About this event</h5>
      {props.event.content && (
        <div className={"ion-margin-top"}>
          <TrixContent content={props.event.content} />
        </div>
      )}

      {props.event.allow_signup ? (
        <div>
          <h5 className={"separator-heading"}>Attending this event?</h5>
          <IonNote>
            {props.event.signups === 1
              ? props.event.signed_up
                ? "You are attending"
                : "1 other person is attending"
              : `${props.event.signups} people are attending` + (props.event.signed_up ? ", including you" : "")}
          </IonNote>

          <IonGrid className={"ion-no-padding ion-padding-top"}>
            <IonRow>
              <IonCol size={"6"}>
                <IonButton onClick={props.event.signed_up ? unSignUp : () => {}} fill={props.event.signed_up ? "outline" : "solid"} expand={"block"}>
                  Not Attending
                </IonButton>
              </IonCol>
              <IonCol size={"6"}>
                <IonButton onClick={props.event.signed_up ? () => {} : signUp} fill={props.event.signed_up ? "solid" : "outline"} expand={"block"}>
                  Attending
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </div>
      ) : (
        ""
      )}

      {props.event.attachments.length ? (
        <>
          <h5 className={"separator-heading"}>{t("attachments")}</h5>
          <Attachments attachments={props.event.attachments} />
        </>
      ) : (
        ""
      )}
    </IonContent>
  );
};
